import { HermesFab } from "@/components/hermes/HermesFab";
import { useHermes } from "@/components/hermes/HermesProvider";
import { useCustomerChat } from "./CustomerChatProvider";

/** 全屏客户聊天时不渲染；否则仅保留 Hermes FAB（不再显示客户头像条） */
export function CustomerChatDock() {
  const { isFullscreen } = useCustomerChat();
  const { open: hermesOpen } = useHermes();

  if (isFullscreen || hermesOpen) return null;

  return <HermesFab />;
}
